import { put, select } from 'redux-saga/effects';
import { resultsConfigSelector, quoteFormSelector } from 'ctm-selectors';

/**
 * If user go back to the cover type page, the staged value should be reset to the initial value.
 * @see filter_store_mapping.js coverTypeDispatchMapping
 * @param {*} action event
 */
const setCoverTypeValueSaga = function* (action) {
    const resultsConfig = yield select(resultsConfigSelector);
    const stagedValue = resultsConfig.getIn('helpers.filters.coverType'.split('.'));

    const quoteForm = yield select(quoteFormSelector);
    const initialFormValue = quoteForm.getIn('coverDetail.coverType'.split('.'));
    if (initialFormValue && action.identifier === 'coverDetail.coverType' && action.stateKey === 'vertical.quote' && stagedValue !== initialFormValue) {
        yield put({
            type: 'SET_FILTER_VALUE',
            filter: 'coverType',
            initialFormValue
        });
        yield put({
            type: 'SET_FILTER_ACTION',
            resultsStateKey: 'filters.coverType',
            resultsStagedStateKey: 'helpers.filters.coverType',
            formStateKey: 'coverDetail.coverType'
        });
    }
};

export default ['SET_VALUE', setCoverTypeValueSaga];
